import { v3 } from "../short3";
import * as Maths3 from "../Maths3";
import { AbstractIntersectionHandler } from "./AbstractIntersectionHandler";

import { Matrix4, Object3D, Plane, Ray, Sphere, Vector3 } from "three";

//statische Hilfsvariablen, die in isIntersectingTriangle benutzt werden,
//aber aus Performancegründen nicht bei jedem Methodenaufruf neu erzeugt werden

const plane = new Plane();
const ray = new Ray();
const pointHolder1 = v3();
const pointHolder2 = v3();

/**
 * Abstrakte Basisklasse für alle IntersectionHandler, deren Geometrie eine zentrale
 * Achse (Ray) aufweist, auf die alle Schnittpunkte projeziert werden
 */
export abstract class AbstractAxisIntersectionHandler extends AbstractIntersectionHandler {
  constructor(objects: Object3D[], options: any) {
    super(objects, options);
  }

  isIntersectionSphere(sphere: Sphere): boolean {
    return this.getGeometryInWorldSpace().isIntersectionSphere(sphere);
  }

  abstract isIntersectingTriangle(a: Vector3, b: Vector3, c: Vector3): boolean;
  abstract getGeometryInLocalSpace(): any; // Should return { origin: Vector3, direction: Vector3 } interface?
  abstract getGeometryInWorldSpace(): any;

  intersectTriangle(
    a: Vector3,
    b: Vector3,
    c: Vector3,
    backfaceCulling: boolean,
    worldMatrix: Matrix4,
    pushIntersectionCallback: (intersection: any) => void,
  ): void {
    const geomLocal = this.getGeometryInLocalSpace();
    let rayIsInTriangle = false;
    let point: Vector3 | null = null;
    if (this.isIntersectingTriangle(a, b, c)) {
      if (Maths3.isTriangleDegenerated(a, b, c)) {
        return;
      }
      ray.set(geomLocal.origin, geomLocal.direction);
      point = ray.intersectTriangle(a, b, c, backfaceCulling, pointHolder1);
      if (!point) {
        plane.setFromCoplanarPoints(a, b, c);
        const d = geomLocal.direction.dot(plane.normal);
        if (d > 0 && backfaceCulling) {
          return;
        }
        point = pointHolder1
          .copy(a)
          .add(b)
          .add(c)
          .multiplyScalar(1 / 3);
        point = ray.closestPointToPoint(point, pointHolder2);
      } else {
        rayIsInTriangle = true;
      }
    }
    if (point) {
      point.applyMatrix4(worldMatrix);
      const geomWorld = this.getGeometryInWorldSpace();
      const distance = point.distanceTo(geomWorld.origin);
      pushIntersectionCallback({
        point: point.clone(),
        distance,
        rayIsInTriangle,
      });
    }
  }

  flushIntersectionsOfCurrentObject(intersections: any[]): void {
    if (intersections.length == 0) {
      return;
    }

    intersections.sort((a, b) => a.distance - b.distance); // fixed sort (a.distance < b.distance is boolean, sort expects number)
    const nearestExact = intersections.find((i) => i.rayIsInTriangle);

    if (nearestExact) {
      this.intersectioncallback(nearestExact);
      return;
    }

    const medianInexact = intersections[Math.floor(intersections.length / 2)];
    this.intersectioncallback(medianInexact);
  }
}
